import React, { useState } from "react";
import { Skeleton } from "@material-ui/lab";
import ModalImageCors from "../ModalImageCors";

const ImageWithSkeleton = ({ imageUrl, body }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div>
      <div style={{ position: "relative", width: 250, height: 200 }}>
        {!loaded && (
          <Skeleton
            variant="rect"
            width={250}
            height={200}
            animation="wave"
            style={{ borderRadius: 8 }}
          />
        )}

        <ModalImageCors
          imageUrl={imageUrl}
          onLoad={() => setLoaded(true)}
          style={{
            display: loaded ? "block" : "none",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />
      </div>

      {body && loaded && (
        <span
          style={{
            maxWidth: "260px",
            display: "inline-block",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            marginTop: 8,
          }}
        >
          {body}
        </span>
      )}
    </div>
  );
};

export default ImageWithSkeleton;
